import { Component } from '@angular/core';

@Component({
    selector: 'ifs-password-reset-done',
    templateUrl: './password-reset-done.component.html',
    standalone: false
})
export class PasswordResetDoneComponent {}

